import { render } from "./tdcRequestForm.vue?vue&type=template&id=3455cec8&scoped=true"
import script from "./tdcRequestForm.vue?vue&type=script&lang=js"
export * from "./tdcRequestForm.vue?vue&type=script&lang=js"

import "./tdcRequestForm.vue?vue&type=style&index=0&id=3455cec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3455cec8"]])

export default __exports__